import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const GoogleColors = createInteractiveColorVars('google');
const GoogleColorsLightValues = Object.freeze({
    base: {
        default: '#f2f2f2',
        action: '#c2c2c2',
        active: '#f2f2f2',
        activeAction: '#c2c2c2',
    },
    text: {
        default: '#1f1f1f',
        action: '#1f1f1f',
        active: '#1f1f1f',
        activeAction: '#1f1f1f',
    },
});
const GoogleColorsDarkValues = Object.freeze({
    base: {
        default: '#f2f2f2',
        action: '#c2c2c2',
        active: '#f2f2f2',
        activeAction: '#c2c2c2',
    },
    text: {
        default: '#1f1f1f',
        action: '#1f1f1f',
        active: '#1f1f1f',
        activeAction: '#1f1f1f',
    },
});

export { GoogleColors, GoogleColorsDarkValues, GoogleColorsLightValues };
